import Type from './Type';
export function isIPadding(node) {
    return node.type === Type.Padding;
}
export default isIPadding;    //# sourceMappingURL=isIPadding.js.map
